import React from 'react'

import { sharedData } from '../../../models/shared_data'
import { AddressInput } from '../../cart/make_order/address_input.component'

import { debounceTime } from 'rxjs/operators';
import { Subject } from 'rxjs';

import addressModel from './address.model';

export class AddressesComponent extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      addressCreation: false,
      newAddress: null,
      error: false
    }

    this.addressCreationToggle = this.addressCreationToggle.bind(this)
    this.newAddressCreate = this.newAddressCreate.bind(this)
  }

  setNewAddr() {
    this.setState({
      newAddress: {
        city: '',
        street: '',
        korp: '',
        dom: '',
        kv: ''
      }
    })
  }


  componentWillMount() {
    this.setNewAddr()
    this.eventS = new Subject()
    this.save = this.eventS
      .debounceTime(800)
      .subscribe((addr)=> {
        addressModel.update(addr)
          .subscribe(()=> {

          })
      })
  }

  componentWillUnmount() {
    this.save.complete()
    this.eventS.complete()
  }

  addressChanged(addr, prms) {
    Object.keys(prms).forEach((k)=> {
      addr[k] = prms[k]
    })
    this.forceUpdate()
    this.eventS.next(addr)
  }

  newAddressChanged(prms) {
    this.setState({
      newAddress: prms
    })
  }

  remove(addr, e) {
    e.preventDefault()
    if(!confirm('Удалить?')) {
      return
    }

    addressModel.remove(addr.id)
      .subscribe((data)=> {
        sharedData.data.client.addresses = data.list

        this.forceUpdate()
      })
  }

  newAddressCreate(e) {
    e.preventDefault()
    this.setState({
      error: false
    })
    addressModel.create(this.state.newAddress)
      .subscribe((data)=> {
        sharedData.data.client.addresses = data.list

        if(Object.keys(data.errors).length > 0) {
          this.setState({
            error: true
          })
        } else {
          this.addressCreationToggle(null)
        }

        this.forceUpdate()
      })
  }

  addressCreationToggle(e) {
    if(e)
      e.preventDefault()
    this.setState({
      addressCreation: !this.state.addressCreation
    }, ()=> {
      if(this.state.addressCreation) {
        this.setNewAddr()
      }
    })
  }

  render() {
    const addresses = sharedData.data.client.addresses
    let st = this.state
    return (
      <div>
      { addresses.map((addr, index)=> (
        <div className="profile-address-item" key={index}>
          <AddressInput
            header=""
            selectNotAllowed={true}
            address={addr}
            onChange={(prms) => this.addressChanged(addr, prms)}
          />
          <a href="" className="btn btn--red" onClick={(e)=> this.remove(addr, e)}>Удалить</a>
        </div>
      ))
      }
      { st.addressCreation &&
        <div>
          <AddressInput
            header="Новый адрес"
            selectNotAllowed={true}
            address={st.newAddress}
            error={st.error}
            onChange={(prms) => this.newAddressChanged(prms)}
          />
          <button className="btn btn--blue" onClick={(e)=> this.newAddressCreate(e)}>Создать</button>
        </div>
      }
      { !st.addressCreation &&
        <a href="" className="btn btn--blue" onClick={this.addressCreationToggle}>Добавить новый адрес</a>
      }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/javascript/website_default/js/react/profile/addresses/addresses.component.jsx